export const getTabIntesection = (id: string, el: HTMLElement) => {
  const { top: rectTop, bottom: rectBottom } = el.getBoundingClientRect();
  const scrollMargin = +getComputedStyle(el).scrollMarginTop?.replace('px', '');
  const top = rectTop - scrollMargin;
  const bottom = rectBottom - scrollMargin;

  const intersectedHeight = Math.min(window.innerHeight, bottom) - Math.max(0, top);
  const intersectRatio = intersectedHeight / (bottom - top);
  return {
    id,
    top,
    bottom,
    intersectRatio,
  };
};

export const scrollToTab = (id: string) => {
  const elem = document.querySelector<HTMLDivElement>(`.livescores-calendar-tab[data-tab-id="${id}"]`);
  elem?.scrollIntoView({ behavior: 'instant', block: 'start' });
  elem?.focus({ preventScroll: true });
};
